import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-treelist-badge-cell',
  template: `<span>{{ displayLabel }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreelistBadgeCellComponent {
  @Input() value: any;
  @Input() valueMap: { value: any; label: string }[] = [];

  get displayLabel(): string {
    const entry = this.valueMap?.find(m => m.value === this.value);
    return entry ? entry.label : (this.value ?? '');
  }
}
